import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import PermissionsService from '../../../services/permissions';
import NoAccess from '../../../components/uiframeworks/noAccess';
import VesselRequisitionsList from '../../../components/vessels/requisitions/general/list';

interface VesselRequisitionsListPageProps {
}

const VesselRequisitionsListPage: React.FC<VesselRequisitionsListPageProps> = (props: VesselRequisitionsListPageProps) => {
    const {user, topbar} = useStore();
    const hasPermission = PermissionsService.hasPermission(['vessels.requisitions.read.all', 'vessels.requisitions.read.me'], user.permissions);
    
    useEffect(() => {
        topbar.show('Vessel Requisitions', [
            {key: 'home', icon: faHome},
            {key: 'vessel requisitions', text: 'Vessel Requisitions'}
        ]);
    }, []);

    return <Stack>
        {hasPermission ? <VesselRequisitionsList /> : null}
        {!hasPermission ? <NoAccess /> : null}
    </Stack>;
};

export default VesselRequisitionsListPage;
